export default {"src":"/_next/static/media/icon-adeptus.3bb93139.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};